import type React from 'react';
import { Text, Stack } from 'braid-design-system';
import { observer } from 'mobx-react';
import { parseAndSplitHtmlText } from '../../../../utils/parseAndSplitHtmlText';
import HotjarMask from '../../../common/HotjarMask';
import SimpleFormat from '../../../common/SimpleFormat';

interface Props {
  content: string;
  isSecondary?: boolean;
}

const HtmlContent: React.FC<Props> = ({ content, isSecondary = true }) => (
  <Stack space="xsmall">
    {parseAndSplitHtmlText(content).map((lines, index) => (
      <Text key={index} tone={isSecondary ? 'secondary' : 'neutral'}>
        <HotjarMask>
          <SimpleFormat text={lines} />
        </HotjarMask>
      </Text>
    ))}
  </Stack>
);

export default observer(HtmlContent);
